import React, { useState } from "react";
import { motion } from "framer-motion";
import { Zap, Calendar, Star } from "lucide-react";

const EventTabs = () => {
  const [activeTab, setActiveTab] = useState("live");

  return (
    <div className="mb-5">
      <div className="flex mb-4 border-b border-gray-700">
        <motion.button
          className={`pb-2 px-3 text-sm font-medium flex items-center ${
            activeTab === "live"
              ? "text-orange-500 border-b-2 border-orange-500"
              : "text-gray-400"
          }`}
          onClick={() => setActiveTab("live")}
          whileTap={{ scale: 0.97 }}
        >
          <Zap
            className={`w-4 h-4 mr-1 ${
              activeTab === "live" ? "text-orange-500" : "text-gray-400"
            }`}
          />
          En vivo
        </motion.button>

        <motion.button
          className={`pb-2 px-3 text-sm font-medium flex items-center ${
            activeTab === "upcoming"
              ? "text-orange-500 border-b-2 border-orange-500"
              : "text-gray-400"
          }`}
          onClick={() => setActiveTab("upcoming")}
          whileTap={{ scale: 0.97 }}
        >
          <Calendar
            className={`w-4 h-4 mr-1 ${
              activeTab === "upcoming" ? "text-orange-500" : "text-gray-400"
            }`}
          />
          Próximos
        </motion.button>

        <motion.button
          className={`pb-2 px-3 text-sm font-medium flex items-center ${
            activeTab === "highlights"
              ? "text-orange-500 border-b-2 border-orange-500"
              : "text-gray-400"
          }`}
          onClick={() => setActiveTab("highlights")}
          whileTap={{ scale: 0.97 }}
        >
          <Star
            className={`w-4 h-4 mr-1 ${
              activeTab === "highlights" ? "text-orange-500" : "text-gray-400"
            }`}
          />
          Destacados
        </motion.button>
      </div>
    </div>
  );
};

export default EventTabs;
